export default __webpack_public_path__ + "static/media/delete-black.2ab21447.svg";